import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { RcQuotesStyles } from './BackOfficeVehicleQuotes.styles';
import { confirmAlert } from '../../../common/utils/alerts';
import {
  addQuoteToCartAncillariAutoBackOffice,
  loadAutoQuotes, removeBackOfficeQuoteFromCart, resetAutoQuotes, updateAutoQuotesData,
} from '../../../features/backofficeResults/backofficeResultsActions';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import { RiskContainer } from '../../AncillariAutoProduct/styles/AncillariAutoResultPage.styles';
import AncillariAutoModalButtons from '../../AncillariAutoProduct/components/AncillariAutoModalButtons';
import AncillariAutoModal from '../../AncillariAutoProduct/components/AncillariAutoModal';
import { EstimateContainer } from '../../../common/components/redesignComponents/common/Redesign.styles';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import { AvvisoAlert } from '../../RcQuotes.styles';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import AncillariAutoSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/AncillariAutoSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';

function BackOfficeAncillariAutoQuotes() {
  const { requestToken } = useParams();

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const state = useSelector((store) => store.backofficeResults.auto_quotes);
  const {
    loading,
    requestInfo,
    processingQuote,
    quotations,
    addingQuote,
    riskQuotes,
  } = state;

  useEffect(() => {
    loadAutoQuotes(requestToken);

    return () => {
      resetAutoQuotes();
    };
  }, []);

  useEffect(() => {
    if (quoteTypes.length === 0) {
      getQuoteTypes();
    }
  }, [quoteTypes]);

  useEffect(() => {
    if (requestInfo !== null && requestInfo.quotations) {
      updateAutoQuotesData(requestInfo);
    }
  }, [requestInfo]);

  //   const modifyData = () => {
  //     navigate(`/backoffice/quote/${requestToken}/ancillari-auto`);
  //   };

  if (loading) {
    return <PageLoading />;
  }

  const fetchQuotes = () => {
    loadAutoQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addQuoteToCartAncillariAutoBackOffice(quoteId, fetchQuotes));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeBackOfficeQuoteFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotes && riskQuotes[type.id] !== undefined) {
        for (let i = 0; i < riskQuotes[type.id].length; i++) {
          const item = riskQuotes[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  return (
    <Layout>
      <V2FontImport />
      <RcQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <AncillariAutoSummaryCard
              customer={requestInfo.customer}
              insuranceRequest={requestInfo}
              vehicle={requestInfo.vehicle}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotes}
              getTotal={getTotal}
              rcTypeLabel={processingQuote?.product_name}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                    <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                      <button className="btn btn-success px-2 py-1">Tutorial</button>
                    </div>
                  )} */}
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>
          {quotations && !quotations.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <AncillariAutoModalButtons
                          insuranceRequest={requestInfo}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={riskQuotes}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <AncillariAutoModal
                    insuranceRequest={requestInfo}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>
      </RcQuotesStyles>
    </Layout>
  );
}

export default BackOfficeAncillariAutoQuotes;
